const MIN_KEYBOARD_HEIGHT = 300;

export const isMobile = window.innerWidth < 768;
export const shouldHandleKeyboard =
  isMobile &&
  window.screen.height - MIN_KEYBOARD_HEIGHT > window.visualViewport.height;
